module.exports = __webpack_public_path__ + "static/img/qiChe.da87289a.jpg";